import Layout from '@/components/layout'
import { SignedIn, SignedOut } from '@clerk/clerk-react'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthProvider'

export default function SpeechToolkit() {
  const { currentOrg, appUserLoaded } = useAuth()
  const isEligible = appUserLoaded && !!currentOrg

  return (
    <Layout>
      <div className="w-full max-w-4xl p-6">
        <SignedIn>
          {!isEligible ? (
            <div className="flex flex-col gap-3">
              <h1 className="text-2xl font-bold">Speech Toolkit</h1>
              <p className="text-sm text-muted-foreground">
                Available for paid plans only. Please purchase a plan to access this page.
              </p>
              <div className="flex gap-2 flex-wrap">
                <Link to="/paddle-checkout">
                  <Button variant="outline" disabled={!appUserLoaded}>
                    Purchase a plan now
                  </Button>
                </Link>
                <Link to="/learning-toolkit">
                  <Button variant="outline">Back to Learning &amp; Toolkit</Button>
                </Link>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              <div>
                <h1 className="text-2xl font-bold">Speech Toolkit</h1>
                <p className="text-sm text-muted-foreground">Stub page — content coming soon.</p>
              </div>

              <Link to="/learning-toolkit">
                <Button variant="outline">Back to Learning &amp; Toolkit</Button>
              </Link>
            </div>
          )}
        </SignedIn>

        <SignedOut>
          <div className="flex flex-col gap-3">
            <h1 className="text-2xl font-bold">Speech Toolkit</h1>
            <p className="text-sm text-muted-foreground">Please sign in to access this page.</p>
            <a href="/sign-in">
              <Button variant="outline">Sign in</Button>
            </a>
          </div>
        </SignedOut>
      </div>
    </Layout>
  )
}

